export default __webpack_public_path__ + "static/user3-4cce79cad2e1fd383a0d9335eef213ba.jpg";